// extracted by mini-css-extract-plugin
module.exports = {"iconStyle":"FreeReturnPolicy_iconStyle__cJ3Cs","policyContainer":"FreeReturnPolicy_policyContainer__rBAn_"};